/* eslint-disable max-len */
import { createContext, useContext } from 'react';

/** @typedef {import('./auth-storage').AuthenticationState} AuthenticationState */

/**
 * @typedef AuthenticationContextBase
 * @property {(redirectTo?: string) => Promise<void>} login
 * @property {(redirectTo?: string) => Promise<void>} logout
 * @property {() => Promise<void>} callback
 * @property {(email: string, redirectTo?: string) => Promise<void>} resetPassword
 * @property {object} authentication
 * @property {(state: AuthenticationState) => void} setAuthentication
 */

/** @typedef {AuthenticationContextBase & AuthenticationState} AuthenticationContextObject */

/**
 * @type {import('react').Context<AuthenticationContextObject>}
 */
export const AuthenticationContext = /*#__PURE__*/createContext(null);

/**
 * Hook to retrieve the current authentication context
 *
 * @returns {AuthenticationContextObject}
 */
export function useAuthentication() {
  return useContext(AuthenticationContext) || null;
}